import React, { FunctionComponent, useEffect } from "react";
import { UIConfigurationContext } from "../../common/contexts/ui-configurationContext";
import { Facilitator } from "../facilitator";
import { Card, CardContent, Grid } from "@mui/material";

import { FormType, withForm } from "../../common/ui-form";
import { SchoolFieldSet } from "./SchoolFieldSet";
import { ISchoolModel } from "../models/ISchoolModel";
import { getFacilitatorSchoolControlState } from "./facilitatorSchoolControlState";
import { getFacilitatorSchoolFormValidations } from "./facilitatorSchoolValidations";
import { useParams } from "react-router-dom";
import FacilitatorSchoolService from "./facilitatorSchoolService";
import { toast } from "react-toastify";
import { getErrorMessage, hasAnyErrors } from "../../common/utilities/httpHandleErrors";

const FacilitatorEditSchoolForm = withForm<
    ISchoolModel,
    FormType<ISchoolModel>
>(SchoolFieldSet);


export const FacilitatorEditSchool: FunctionComponent = () => {
    const uiConfigData = React.useContext(UIConfigurationContext);
    const { schoolId } = useParams();
    const intialValues = (): ISchoolModel => {
        return {
            state:'',
            address: '',
            userId: 0,
            schoolName: '',
            email: '',
            userName: '',
            password: '',
            mobileNumber: '',
            foundationPrograms: [],
            olympiadExams: [],
            chairmanName:'',
            chairmanWhatsAppContact:'',
            principalName:'',
            principalWhatsAppContact:'',
            programInChargeName:'',
            programInchargeWhatsAppContact:'',
            abhyasaBharathiMagazineAccess:false,
            videoLessionPrograms:[]
        };
    };

    const [schoolData, setSchoolData] = React.useState<ISchoolModel>();


    const loadData = () => {
        if (schoolId) {
            const schoolIdNumber = parseInt(schoolId);
            FacilitatorSchoolService.Get(schoolIdNumber).then((res) => {
                if (hasAnyErrors(res)) {
                    toast.error(getErrorMessage(res));
                }
                else {
                    setSchoolData(res.data.data);
                }

            }).catch((err) => {
                toast.error('Error in fectching the school details');
            });
        }
    }
    useEffect(() => {
        loadData();
    }, []);


    return (
        <Facilitator>
            <Grid container>
                <Grid item xs={12}>
                    <Card sx={{ height: "100%" }}>
                        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                            {schoolData && <FacilitatorEditSchoolForm
                                enableReintialize
                                formValues={schoolData}
                                pageTitle="Edit School"
                                pageSubtitle="Update school details and program access"
                                getValidationSchema={(v: ISchoolModel) =>
                                    getFacilitatorSchoolFormValidations(v)
                                }
                                getControlState={(v: ISchoolModel) =>
                                    getFacilitatorSchoolControlState(v)
                                }
                            />
                            }
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Facilitator>);
}